import * as TYPES from '../types';

export const getAllResearchAction = () => {
    return {
        type: TYPES.GET_ALL_RESEARCH,
    };
};

export const getAllResearchSuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_RESEARCH_SUCCESS,
        payload: payload
    };
};